import { render, staticRenderFns } from "./DadosEdital.vue?vue&type=template&id=9dd7f5f6&scoped=true"
import script from "./DadosEdital.vue?vue&type=script&lang=js"
export * from "./DadosEdital.vue?vue&type=script&lang=js"
import style0 from "./DadosEdital.vue?vue&type=style&index=0&id=9dd7f5f6&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dd7f5f6",
  null
  
)

export default component.exports